function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Upload as AntUpload } from "antd";
import { UiUpload } from "./Upload.style";
/**
 * 上傳組建可拖移
 */

const {
  Dragger: AntDragger
} = AntUpload;

const Upload = ({
  fileList,
  message = "",
  limit = 20,
  acceptFileType,
  prompt,
  multiple,
  onChange
}) => {
  const [sendFile, setFileSend] = useState([]);
  const propsUpload = {
    beforeUpload: () => {
      return false;
    },

    onChange(info) {
      const listFiles = info.fileList;
      const newArrayFiles = listFiles.map(file => file.originFileObj ? file.originFileObj : file);
      setFileSend(newArrayFiles);
    },

    multiple,
    showUploadList: true,
    accept: acceptFileType,
    maxCount: multiple ? limit : 1,
    fileList
  };
  useEffect(() => {
    const nextSendFile = sendFile.filter((item, index) => sendFile.indexOf(item) === index);
    onChange && onChange(nextSendFile);
  }, [sendFile]);
  return /*#__PURE__*/React.createElement(UiUpload, null, /*#__PURE__*/React.createElement(AntDragger, _extends({
    name: "file"
  }, propsUpload), /*#__PURE__*/React.createElement("p", {
    className: "ant-upload-drag-icon"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-icons"
  }, "cloud_upload")), /*#__PURE__*/React.createElement("p", {
    className: "text"
  }, "\u4E0A\u50B3\u6A94\u6848"), /*#__PURE__*/React.createElement("p", {
    className: "prompt"
  }, prompt)), message !== "" && /*#__PURE__*/React.createElement("div", {
    className: "message"
  }, /*#__PURE__*/React.createElement("i", {
    className: "material-icons"
  }, "cancel"), message));
};

export default Upload;
Upload.propTypes = {
  fileList: PropTypes.array,
  message: PropTypes.string,
  limit: PropTypes.number,
  acceptFileType: PropTypes.string,
  prompt: PropTypes.element,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  deleteFile: PropTypes.func
};